import React from 'react';
import { Field, getIn } from 'formik';
import { Textarea as TextareaField } from '../../form';

const Textarea = ({
  resetValue,
  placeholder,
  onChange,
  readOnly,
  label,
  ...rest
}) => (
  <Field {...rest}>
    {({ field, form }) => {
      const error = getIn(form.errors, field.name);
      const touch = getIn(form.touched, field.name);

      const onReset = () => {
        const initialValue = getIn(form.initialValues, field.name);
        form.setFieldTouched(field.name, false);
        form.setFieldValue(field.name, resetValue || initialValue || '');
      };

      const onChangeCustom = (e) => {
        field.onChange(e);
        if (onChange) {
          onChange(e);
        }
      };

      return (
        <TextareaField
          {...field}
          label={label}
          onChange={onChangeCustom}
          onReset={onReset}
          placeholder={placeholder}
          readOnly={readOnly}
          error={!readOnly && touch && error}
        />
      );
    }}
  </Field>
);

export default Textarea;
